import { gql } from '@apollo/client';

import { groupFragment } from '../fragments';

export default gql`
  mutation CreateGroup($courseId: String!, $input: CreateGroupInput!) {
    group(courseId: $courseId, input: $input)
      @rest(
        type: "Group"
        path: "courses/{args.courseId}/groups"
        method: "POST"
      ) {
      ...Group
    }
  }
  ${groupFragment}
`;
